"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.createRemoteComponent = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
var react_1 = __importDefault(require("react"));
var useRemoteComponent_1 = require("./hooks/useRemoteComponent");
var createRemoteComponent = function (props) {
    var useRemoteComponent = useRemoteComponent_1.createUseRemoteComponent(props);
    var remoteComponent = function (_a) {
        var url = _a.url, _b = _a.fallback, fallback = _b === void 0 ? null : _b, render = _a.render, props = __rest(_a, ["url", "fallback", "render"]);
        var _c = useRemoteComponent(url), loading = _c[0], err = _c[1], Component = _c[2];
        if (loading) {
            return fallback;
        }
        if (render) {
            return render({ err: err, Component: Component });
        }
        if (err || !Component) {
            return react_1["default"].createElement("div", null,
                "Unknown Error: ",
                (err || "UNKNOWN").toString());
        }
        return react_1["default"].createElement(Component, __assign({}, props));
    };
    return remoteComponent;
};
exports.createRemoteComponent = createRemoteComponent;
//# sourceMappingURL=createRemoteComponent.js.map